@if (loading) {
  <motn-spinner></motn-spinner>
}

@if (!loading) {
  @if (table$ | async; as table) {
    <motn-sort-table
      [hidden]="table.rows.length === 0"
      [table$]="table$"
      (renderedRows$)="tableRowsRendered($event)"
    ></motn-sort-table>

    @if (table.rows.length === 0) {
      <div class="empty-state-container">
        <i class="empty-state-icon fa-regular fa-magnifying-glass"></i>
        <p class="empty-state-text">{{ searchTerm ? 'No hubs match your search' : 'No hubs found' }}</p>
      </div>
    }
  }
}

@if (editingHub) {
  <motn-hub-editor
    [hubId]="editingHub"
    (clickedOutside$)="editingHub = null"
    (saved$)="editorSaved($event)"
  ></motn-hub-editor>
}
